import { charPerToken } from "@moe/priv/utils";
import { MessageExample } from "@web/route-services/studio/schema";
import { useFormContext, useWatch } from "react-hook-form";

/**
 * Display a summary of how many permanent and ephemeral tokens are used by the current form values.
 */
export function TokenSummary() {
  const form = useFormContext();

  // Subscribe to individual fields so the summary updates in real-time.
  const name = (useWatch({ control: form.control, name: "name" }) as string) ?? "";
  const description = (useWatch({ control: form.control, name: "description" }) as string) ?? "";
  const greeting = (useWatch({ control: form.control, name: "greeting" }) as string) ?? "";
  const definitions = (useWatch({ control: form.control, name: "definitions" }) as string) ?? "";
  const messageExamples = (useWatch({ control: form.control, name: "messageExamples" }) as MessageExample[]) ?? [];

  const messageExamplesLength = messageExamples?.map((msg) => msg.content).join("").length ?? 0;
  const permanentTokens = Math.ceil((name.length + description.length) / charPerToken);
  const totalTokens = Math.ceil(
    (name.length + description.length + messageExamplesLength + definitions.length + greeting.length) / charPerToken
  );

  return (
    <table className="text-tx-tertiary font-medium md:text-lg">
      <h1 className="text-tx-secondary font-semibold md:text-lg">Token Summary</h1>
      <tbody>
        <tr>
          <td className="pr-4">
            <b className="text-sm">Permanent:</b>
          </td>
          <td className="text-right text-sm">{permanentTokens} Tokens</td>
        </tr>
        <tr>
          <td className="pr-4">
            <b className="text-sm">Total:</b>
          </td>
          <td className="text-right text-sm">{totalTokens} Tokens</td>
        </tr>
      </tbody>
    </table>
  );
}
